import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';

@Component({
    selector: 'mon-panel-next',
    template: `
        <mon-tabs
                [options]="tabOptions"
                [showSearch]="showSearch"
                [(status)]="activeTab"
                (onStatus)="onStatus.emit($event)"
                (onSearch)="onSearch.emit($event)"
                [search]="search"
                [minSearchLength]="minSearchLength"
                [maxOptionsDisplay]="maxTabsDisplay">
            <ng-content select="tabs-extra"></ng-content>
        </mon-tabs>
        <div class="panel panel-monsido-card mon-panel card" [ngClass]="panelClass">
            <mon-panel-header-next [faIcon]="faIcon"
                              [pHeader]="header"
                              [subHeader]="subHeader"
                              [hideHr]="hideHr"
                              *ngIf="showHeader">
                <ng-content select="panel-header"></ng-content>
            </mon-panel-header-next>
            <div class="panel-body card-body">
                <ng-content select="panel-body"></ng-content>
            </div>
        </div>
    `,
    standalone: false,
})
export class MonPanelComponent implements OnInit, OnChanges {
    @Input() header: string = '';
    @Input() subHeader: string = '';
    @Input() faIcon?: string;
    @Input() tabOptions: any[] = [];
    @Input() activeTab?: any;
    @Input() search?: any;
    @Input() minSearchLength: number = 1;
    @Input() showSearch: boolean = false;
    @Input() panelClass?: string;
    @Input() hideHr: boolean = false;
    @Input() maxTabsDisplay: number = 3;

    @Output() onSearch = new EventEmitter<any>();
    @Output() onStatus = new EventEmitter<any>();

    showHeader: boolean = false;

    ngOnInit (): void {
        this.showHeader = this.header !== '';
        this.tabOptions = this.tabOptions || [];
    }

    ngOnChanges () {
        this.showHeader = this.header !== '';
    }
}
